import React from 'react'
import styled from '@emotion/styled'
import { downloadUrl } from 'utils'
import { Locale, Translation } from 'locale'
import { SplitButtonDropdown, SplitButtonType, ActionItem } from 'view/components/menus'
import { ModalConsumerProps, withModal } from 'view/shared/modal'
import { OrderUploadDialog } from 'view/shared/orderUpload/OrderUploadDialog'
import { AddAssetDialog } from './AddAssetDialog'
import orderUploadTemplateUrl from './assets/OrderUploadTemplate.xlsx'
import { createStructuredSelector } from 'reselect'
import { canUploadPositionsSelector } from 'selectors/permissionSelectors'
import { connect } from 'react-redux'

export interface StagingToolbarProps extends ModalConsumerProps {
  canUploadPositions: boolean
}

const mapStateToProps = createStructuredSelector({
  canUploadPositions: canUploadPositionsSelector
})

const mapDispatchToProps = {}

const SplitButtonStyled = styled(SplitButtonDropdown)`
  max-width: 130px;
`

export class StagingToolbarComponent extends React.Component<StagingToolbarProps> {
  render() {
    if (!this.props.canUploadPositions) {
      return null
    }

    const toolbarActions: ActionItem[] = [
      {
        label: Locale.translate(Translation.TC_ACTION_UPLOAD_SPREADSHEET),
        type: SplitButtonType.Primary,
        onClick: this.handleUploadSpreadsheet,
        enabled: true
      },
      {
        label: Locale.translate(Translation.TC_ACTION_ADD_ASSETS),
        type: SplitButtonType.Primary,
        onClick: this.handleAddAssets,
        enabled: true
      },
      {
        label: Locale.translate(Translation.TC_ACTION_DOWNLOAD_SPREADSHEET),
        type: SplitButtonType.Primary,
        onClick: this.handleDownloadSpreadsheet,
        enabled: true
      }
    ]

    return <SplitButtonStyled dataTestId={toolbarActions[0].label} actions={toolbarActions} maxButtons={1} />
  }

  private handleAddAssets = () => {
    this.props.showModal(<AddAssetDialog />)
  }

  private handleUploadSpreadsheet = () => {
    this.props.showModal(<OrderUploadDialog />)
  }

  private handleDownloadSpreadsheet = () => {
    downloadUrl(orderUploadTemplateUrl, Locale.translate(Translation.TC_DOWNLOAD_ORDER_TEMPLATE_FILENAME))
  }
}

export const StagingToolbar = withModal(connect(mapStateToProps, mapDispatchToProps)(StagingToolbarComponent))
